import { TEnterprise } from "../api/types/Sysadmin";

export const enterpriseDisplayName = (user: TEnterprise) => {
  return [
    user.accountid,
  ].find((name) => !!name) || '';
}